import React, { useEffect } from "react";
import { ReactComponent as CopyIcon } from "icons/copy.svg";
import PropTypes from "prop-types";
import { copyToClipboard } from "utils";

const getInnerHTML = (popover, videoId) => {
  if (popover) {
    return `<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"> <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"> <span class="wistia_embed wistia_async_${videoId} popover=true videoFoam=true" style="display:inline-block;height:100%;position:relative;width:100%">&nbsp;</span></div></div>`;
  }
  return `<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_${videoId} seo=false videoFoam=true" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/${videoId}/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>`;
};

function WistiaPlayer({ videoId, title, url, popover }) {
  const wrapperId = `vt-wistia-${videoId}`;

  useEffect(() => {
    // Wistia embed code
    const script1 = document.createElement("script");
    script1.src = `https://fast.wistia.com/embed/medias/${videoId}.jsonp`;
    script1.async = true;
    const script2 = document.createElement("script");
    script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
    script2.async = true;
    const div = document.createElement("div");
    div.innerHTML = getInnerHTML(popover, videoId);
    const container = document.getElementById(wrapperId);
    container.appendChild(script1);
    container.appendChild(script2);
    container.appendChild(div);

    return () => {
      // Cleanup code
      container.innerHTML = "";
    };
  }, []);

  return (
    <article>
      <div id={wrapperId} />
      {title && (
        <div className="vt-wistia_title" data-testid="vt-wistia_title">
          <h3>{title}</h3>
          <button
            type="button"
            onClick={() => {
              copyToClipboard(url).then(() => {});
            }}
          >
            <CopyIcon />
          </button>
        </div>
      )}
    </article>
  );
}

export default WistiaPlayer;

WistiaPlayer.propTypes = {
  videoId: PropTypes.string.isRequired,
  title: PropTypes.string,
  url: PropTypes.string,
  popover: PropTypes.bool,
};
